export enum FormMode {
  CREATE = 'create',
  EDIT = 'edit',
  DUPLICATE = 'duplicate',
}

export enum EInternationalInvoiceAddFileStatus {
  UPLOADED = 'uploaded',
  FAILED = 'failed',
}

export enum EInternationalInvoiceLinkDocumentStatus {
  SUCCESS = 'success',
  FAILED = 'failed',
  DELETED = 'deleted',
  FILE_NOT_EXIST = 'file_not_exist',
  STORAGE_UNAVAILABLE = 'Storage unavailable',
}
